import { useSignal } from "@emberly/zenith-client";
import { Box, CircularProgress, Slide, Stack, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import { Check as CheckIcon } from "@mui/icons-material";


const useStyles = makeStyles()(
  (theme) => ({
    root: {
      position: "absolute",
      top: "8px",
      left: "50%",
      zIndex: 9999999,
    },
    connectionLostContainer: {
      transform: "translateX(-50%)",
      width: "auto",
      height: "34px",
      background: "rgba(0,0,0,0.8)",
      color: "white",
      borderRadius: "17px",
      padding: theme.spacing(1.25),
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      boxShadow: "0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1)",
    },
    connectionLostSpinner: {
      color: "white"
    },
    connectionRegainedCheck: {
      fontSize: "14px"
    },
    text: {
      lineHeight: "100%",
      whiteSpace: "nowrap"
    }
  })
);


export function ConnectionWidget() {
  const { hasDisconnect } = useSignal();
  const { t } = useTranslation();
  const { classes } = useStyles();

  const [disconnectAndVisible, setDisconnectAndVisible] = useState(hasDisconnect);
  const [mount, setMount] = useState(false);
  const [show, setShow] = useState(false);
  const mountTimerRef = useRef(null);
  const hideTimerRef = useRef(null);

  useEffect(() => {
    if (hasDisconnect) {

      let fn = () => setDisconnectAndVisible((document.visibilityState || "visible") === "visible");
      fn();

      document.addEventListener("visibilitychange", fn, false);

      return () => {
        document.removeEventListener("visibilitychange", fn, false);
        setDisconnectAndVisible(false);
      };
    }
  }, [hasDisconnect]);


  useEffect(() => {
    if (disconnectAndVisible) {
      clearTimeout(mountTimerRef.current);
      clearTimeout(hideTimerRef.current);

      setMount(true);
      const showTimer = setTimeout(() => setShow(true), 1000);

      return () => {
        clearTimeout(showTimer);
        hideTimerRef.current = setTimeout(() => setShow(false), 750);
        mountTimerRef.current = setTimeout(() => setMount(false), 1500);
      }
    }
  }, [disconnectAndVisible]);

  return mount ? (
    <Slide in={show}>
      <Box className={classes.root}>
        <Box className={classes.connectionLostContainer}>
          <Stack direction="row" alignItems="center" spacing={1}>
            {
              hasDisconnect ? (
                <CircularProgress variant="indeterminate" className={classes.connectionLostSpinner} size="14px" />
              ) : (
                <CheckIcon className={classes.connectionRegainedCheck} />
              )
            }
            <Typography variant="subtitle2" className={classes.text}>{hasDisconnect ? t("offline:notify") : t("offline:connected")}</Typography>
          </Stack>
        </Box>
      </Box>
    </Slide>
  ) : null;
}